// Meslek ve dil bilgisi alanları için seçenek listeleri ve yardımcılar.
//
// languageInfo Firestore'da string olarak tutulur ("İngilizce (B2), Almanca (A1)")
// — tablo sütunları, çalışan kartı ve filtreler bu string'i olduğu gibi gösterir.
// Modallardaki çoklu dil editörü bu string'i parse/format yardımcılarıyla kurar;
// eski serbest metin kayıtlar "liste dışı" girdi olarak korunur.

export const PROFESSION_OPTIONS = [
  'Hemşire',
  'Doktor',
  'Eczacı',
  'Diş Hekimi',
  'Veteriner Hekim',
  'Biyolog',
  'Moleküler Biyoloji ve Genetik Uzmanı',
  'Kimyager',
  'Biyokimyager',
  'Ebe',
  'Paramedik',
  'İlk ve Acil Yardım Teknikeri',
  'Laborant',
  'Sağlık Memuru',
  'Fizyoterapist',
  'Diyetisyen',
  'Psikolog',
  'Sosyal Hizmet Uzmanı',
  'İstatistikçi',
  'Mühendis',
  'Yazılım Uzmanı',
  'İşletmeci',
  'İktisatçı',
  'Muhasebeci',
  'Avukat',
  'İnsan Kaynakları Uzmanı',
  'Öğretmen',
  'Teknisyen',
  'Diğer'
];

export const LANGUAGE_OPTIONS = [
  'İngilizce',
  'Almanca',
  'Fransızca',
  'İspanyolca',
  'İtalyanca',
  'Rusça',
  'Arapça',
  'Farsça',
  'Çince',
  'Japonca',
  'Korece',
  'Portekizce',
  'Hollandaca',
  'Yunanca',
  'Azerice',
  'Türkçe',
  'Diğer'
];

export const LANGUAGE_LEVEL_OPTIONS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'Ana Dil'];

// "İngilizce (B2), Almanca (A1)" -> [{ language: 'İngilizce', level: 'B2' }, ...]
// Parantezsiz veya tanınmayan segmentler seviye boş olarak korunur.
export const parseLanguageInfo = (value) => {
  if (!value || typeof value !== 'string') return [];
  return value
    .split(/[,;]/)
    .map((seg) => seg.trim())
    .filter(Boolean)
    .map((seg) => {
      const match = seg.match(/^(.+?)\s*\((.+?)\)$/);
      return match
        ? { language: match[1].trim(), level: match[2].trim() }
        : { language: seg, level: '' };
    });
};

export const formatLanguageInfo = (entries) =>
  (entries || [])
    .filter((e) => e.language && e.language.trim())
    .map((e) => (e.level ? `${e.language} (${e.level})` : e.language))
    .join(', ');
